export default __webpack_public_path__ + "static/media/cfg.4c1e4ecc.jpeg";